import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageVisit } from './utils/visitorTracker';

export default function TrackPageVisits({ children }) {
  const location = useLocation();

  useEffect(() => {
    trackPageVisit(window.location.href);
  }, [location.pathname]);

  return children;
}